import { IonButton, IonHeader, IonImg, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';

// Shared by the Settings list and its option pages; both keep the "Settings" title.
const SettingsHeader: React.FC = () => {
  const history = useHistory();

  return (
    <div className="slotcheck-header">
      <IonHeader className="small-header header-dark">
        <IonToolbar>
          <IonButton
            fill="clear"
            onClick={() => history.goBack()}
            className="icon-back"
            slot="start"
          >
            <IonImg src="assets/images/back-round.png" />
          </IonButton>
          <div className="logo header-title settings-header-title">
            <img src="assets/icon/settings/gear.svg" alt="" className="settings-header-icon" />
            Settings
          </div>
        </IonToolbar>
      </IonHeader>
    </div>
  );
};

export default SettingsHeader;
